import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { GlobalStyles } from './GlobalStyles';
import Home from './pages/Home';
import Workshops from './pages/Workshops';
import Events from './pages/Events';
import Admins from './pages/Admins';
import Resources from './pages/Resources';
import About from './pages/About';
import FreeCoaching from './pages/ContactUs';
import MinistryIncubators from './pages/MinistryIncubators';
import NotFound from './pages/NotFound';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <GlobalStyles />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/workshops" element={<Workshops />} />
          <Route path="/events" element={<Events />} />
          <Route path="/admins" element={<Admins />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<FreeCoaching />} />
          <Route path="/ministry-incubators" element={<MinistryIncubators />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;
